import React from "react";
import { motion } from "framer-motion";

const FeatureItem = ({ number, text }) => {
  return (
    <motion.div
      className="text-center group"
      initial={{ opacity: 0, y: 40, scale: 0.8 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: false, amount: 0.3 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {/* Circle */}
      <motion.div
        className="w-24 h-24 rounded-full bg-gradient-to-br from-red-300 to-cyan-500 
        flex items-center justify-center mx-auto 
        transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl"
        whileHover={{ scale: 1.12, rotate: 2 }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        <motion.span
          className="text-3xl font-cinzel text-white"
          whileHover={{ scale: 1.22 }}
          transition={{ duration: 0.3 }}
        >
          {number}
        </motion.span>
      </motion.div>

      {/* Description */}
      <p className="mt-4 text-sm text-gray-700 font-outfit">{text}</p>
    </motion.div>
  );
};

export default FeatureItem;
